export default __webpack_public_path__ + "static/media/ic-book-ai.e057eae1.svg";